import React from 'react';
import Body from '../static/Body';
import Card from '../static/Card';
import { motion } from 'framer-motion';
import Text from '../elements/TextComponent';
import PricingPage from '../static/PaypalPricing';


interface Props {

}

const Account: React.FC<Props> = () => {


    return (
        <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 20 }}
                transition={{ duration: 0.3 }}
              >
                <Body>
                    <Card width="92%">
                        <Text
                            text="Your Account"
                            fontSize="26px"
                            fontWeight="700"
                            lineHeight="28px"
                            color="#030303"
                            textAlign="left"
                            />
                            <div className='margin-top-10'></div>
                        <Text
                            text="Manage payment plan here."
                            fontSize="16px"
                            fontWeight="400"
                            lineHeight="28px"
                            color="#030303"
                            textAlign="left"
                            />
                    </Card>
                    <Card height='635px' width="92%" preventOverflow>
                        <div style={{marginTop: '-83px'}}>
                            <PricingPage></PricingPage>
                        </div>
                    </Card>
                </Body>
        </motion.div>
    )
}

export default Account;